import axios from './setupAxiosAuth';
import { getAdminApiBaseUrl } from './adminApiBaseUrl';

export type DashboardExportParams = {
  panel: string;
  from_date?: string;
  to_date?: string;
  period?: string;
  bucket?: string;
  conversion_type?: string;
  utm_source?: string;
  utm_medium?: string;
  utm_campaign?: string;
  login_filter?: 'logged_in' | 'anonymous';
  segment?: 'new' | 'returning';
  funnel_step?: 'visited' | 'wishlist' | 'registered' | 'inquiries' | 'orders';
  dimension?: string;
  dimension_value?: string;
};

export type DashboardExportResponse = {
  panel: string;
  total: number;
  rows: Record<string, unknown>[];
  from_date?: string;
  to_date?: string;
  data_through?: string;
  last_updated_at?: string | null;
};

export const fetchDashboardExport = async (
  params: DashboardExportParams
): Promise<DashboardExportResponse> => {
  const response = await axios.get(`${getAdminApiBaseUrl()}/customers/dashboard-export`, {
    params,
  });
  return response.data;
};
